import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchgetSalesTargetWithGoalsByAccountId(id, account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getSalesTargetWithGoalsByAccountId/${id}/${account}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchgetAllOepenDealByAccountId(id, account, isQualified) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllOepenDealByAccountId/${id}/${account}/${isQualified}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchgetAllClosedDealByAccountId(id, account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllClosedDealByAccountId/${id}/${account}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchleadConversionByAccount(account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/leadConversionByAccount/${account}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchcontactByAccountAndId(account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/contactByAccountAndId/${account}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchaccountActivityReportByAccountId(id, account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/accountActivityReportByAccountId/${id}/${account}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchresourceUtilizationReportByAccountId(id, account) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/resourceUtilizationReportByAccountId/${id}/${account}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllEntityScoreForLastSixmonth(type,id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllEntityScoreForLastSixmonth/${type}/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchgetSalesTargetWithGoalsByAccountId,
    FetchgetAllOepenDealByAccountId,
    FetchgetAllClosedDealByAccountId,
    FetchleadConversionByAccount,
    FetchcontactByAccountAndId,
    FetchaccountActivityReportByAccountId,
    FetchresourceUtilizationReportByAccountId,
    FetchAllEntityScoreForLastSixmonth
}